export enum MainAction {
    UPDATE_LOADING = "UPDATE_LOADING",
    UPDATE_COLLAPSED = "UPDATE_COLLAPSED",
    UPDATE_USER_CONFIG = "UPDATE_USER_CONFIG"
}